<template>
    <div class="auth">
        <div class="auth__cover"></div>

        <div class="auth__content">
            <div class="auth__logo">
                <SvgUse
                    :width="40"
                    :height="46"
                    id="logoNetvork"
                    key="Netvork"
                ></SvgUse>
            </div>

            <div class="auth__wrapper">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseAuth',
    props: [],
    data() {
        return {};
    },
    computed: {},
    methods: {},
    beforeMount() {},
};
</script>

<style lang="scss">
@import '../../../scss/utils/mixins.scss';
@import '../../../scss/utils/variables.scss';

.auth {
    width: 100%;
    height: 100%;
    &__cover {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-image: url('/images/auth/auth-bg-xl.png'),
            $color-auth-gradient-bg;
        background-position: center center !important;
        background-size: cover !important;
        background-repeat: no-repeat;
    }
    &__content {
        width: 100%;
        position: absolute;
        padding: 16px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: $color-auth-form-bg;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-height: 100vh;
        overflow-y: auto;
        color: white;
        @include break(md) {
            width: 400px;
            border-radius: 20px;
        }
        @media (max-height: 800px) {
            justify-content: flex-start;
        }
        & > *:first-child {
            margin-top: 50px;
        }
        & > *:last-child {
            margin-bottom: 40px;
        }
    }
    &__logo {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 72px;
        height: 72px;
        flex: none;
        border-radius: 20px;
        background: rgba(45, 47, 51, 1);
        box-shadow: 0 7px 15px rgb(0 0 0 / 10%);
        margin: 0 0 50px;
    }
}
</style>
